import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent.js'
import './Navigation/VerbrauchNavigation.js'
import AuthorizationFilter from '../Authorization/AuthorizationFilter.js'
import './Region/VerbrauchRegion'

export default class Verbrauch extends WebComponent {

  get translationFile() {
    return './views/Verbrauch/i18n.json'
  }

  async connectedCallback() {
    super.connectedCallback()

    if (getNavigationHash() === 'Verbrauch') {
      navigate({to: 'Verbrauch_Ch'});
    }

    this.render()
  }

  getTemplate() {
    return html`
      <div style="display: flex;">
        <div style="flex-grow: 0;">
          <gasmonitoring-frontend-verbrauch-navigation></gasmonitoring-frontend-verbrauch-navigation>
        </div>
        <div id="gasContent" style="flex-grow: 1; margin: 0px 0px 0px 40px; width: 100%; height: 100%; overflow: auto;">
          ${this._getContent()}
        </div>
      </div>
    `
  }

  _getContent() {  //NOSONAR
    // check the rights and redirect to default view in verwaltung if not ok
    if (!AuthorizationFilter.viewAllowed(getNavigationHash())) {
      navigate({to: ''})
      return html``
    }
    switch (getNavigationHash()) {
      case 'Verbrauch_Ch':
        return html`<gasmonitoring-frontend-verbrauch-region region="ch"></gasmonitoring-frontend-verbrauch-region>`
      case 'Verbrauch_Chot':
        return html`<gasmonitoring-frontend-verbrauch-region region="chot"></gasmonitoring-frontend-verbrauch-region>`
      case 'Verbrauch_Dch':
        return html`<gasmonitoring-frontend-verbrauch-region region="dch"></gasmonitoring-frontend-verbrauch-region>`
      case 'Verbrauch_Ail':
        return html`<gasmonitoring-frontend-verbrauch-region region="ail"></gasmonitoring-frontend-verbrauch-region>`
      case 'Verbrauch_Ego':
        return html`<gasmonitoring-frontend-verbrauch-region region="ego"></gasmonitoring-frontend-verbrauch-region>`
      case 'Verbrauch_Egz':
        return html`<gasmonitoring-frontend-verbrauch-region region="egz"></gasmonitoring-frontend-verbrauch-region>`
      case 'Verbrauch_Gaznat':
        return html`<gasmonitoring-frontend-verbrauch-region region="gaznat"></gasmonitoring-frontend-verbrauch-region>`
      case 'Verbrauch_Gvm':
        return html`<gasmonitoring-frontend-verbrauch-region region="gvm"></gasmonitoring-frontend-verbrauch-region>`
      default:
        break
    }
    // default
    return html``
  }
}
customElements.define('gasmonitoring-frontend-verbrauch', Verbrauch)
